import http from './axios'

// 查询列表
const queryPage = ({
    phone,
    channel,
    allowAddWechat,
    pageNo,
    pageSize,
    startTime,
    endTime
}) => {
    return http.get('/manager/loanUser/loanUserPage', {
        phone: phone,
        channel: channel,
        allowAddWechat: allowAddWechat,
        pageNo: pageNo,
        pageSize: pageSize,
        endTime: endTime,
        startTime: startTime
    })
}

const logList = ({
    userId
}) => {
    return http.get('/manager/loanUserQualificationLog/logList', {
        userId
    })
}

// 添加
const addData = ({
    phone,
    lastLoginTime,
    channel,
    allowAddWechat,
}) => {
    return http.json_post('/loanUser/addLoanUser', {
        phone: phone,
        lastLoginTime: lastLoginTime,
        channel: channel,
        allowAddWechat: allowAddWechat,
    })
}


// 编辑
const editData = ({
    id,
    phone,
    lastLoginTime,
    channel,
    allowAddWechat,
}) => {
    return http.json_post('/loanUser/editLoanUser', {
        id: id,
        phone: phone,
        lastLoginTime: lastLoginTime,
        channel: channel,
        allowAddWechat: allowAddWechat,
    })
}

// 删除
const deleteData = ({
    id
}) => {
    return http.get('/loanUser/deleteLoanUser', {
        id: id,
    })
}

export default {
    deleteData,
    queryPage,
    addData,
    editData,
    logList
}